import Layout from 'components/Layout';
import AppShell from 'components/Layout/AppShell';
import useLiterals from 'utils/hooks/useLiterals';
import { useSelector } from 'react-redux';
import { EFFECT_LIST_BOX_UP_IN_VIEW } from 'constants/effects';
import CmsBlocks from 'components/CmsBlocks/v2';
import { BOTTOM_MENU_ACTIONS } from 'components/Layout/components/BottomMenu';
import { USER_LEVEL } from 'constants/global';
import useFeatureGate from 'utils/hooks/useFeatureGate';
import { FEATURE_REGISTRATION_NEW_CLIENT } from 'constants/featureGates';
import UserBox from './components/UserBox';
import ShopBox from './components/ShopBox';
import UserBoxFinishSignup from './components/UserBoxFinishSignup';
import './styles.scss';

const Home = () => {
  const literals = useLiterals('home');
  const { user } = useSelector((state) => state.session);
  // "Termina tu registro" lleva al KYC de alta nueva: solo en celular real.
  const canShowRegistration = useFeatureGate(FEATURE_REGISTRATION_NEW_CLIENT);

  return (
    <Layout
      bottomMenu={{
        type: BOTTOM_MENU_ACTIONS.AUTOMATIC_QUOTER,
      }}
    >
      <div className='home'>
        <CmsBlocks animate={EFFECT_LIST_BOX_UP_IN_VIEW}>
          <AppShell variant='default'>
            <UserBox
              user={user}
              literals={literals}
            />
          </AppShell>
          {canShowRegistration && user?.id && user?.level !== USER_LEVEL.COMPLETE && (
            <AppShell variant='default'>
              <UserBoxFinishSignup literals={literals} />
            </AppShell>
          )}
          <AppShell variant='default'>
            <ShopBox />
          </AppShell>
        </CmsBlocks>
      </div>
    </Layout>
  );
};

export default Home;
